import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { api, errMsg } from "../lib/api";
import { EnvelopeSimple, ArrowLeft, CheckCircle } from "@phosphor-icons/react";

export default function ForgotPassword() {
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/auth/forgot-password", { email });
      setSent(true);
    } catch (err) {
      toast.error(errMsg(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="app-shell w-full max-w-md mx-auto min-h-[100dvh] px-6 py-10 flex flex-col">
      <Link to="/login" className="mb-6 inline-flex items-center gap-2 text-brand-ink2 font-nunito font-semibold text-sm" data-testid="forgot-back-login">
        <ArrowLeft size={18} /> Girişe dön
      </Link>

      {!sent ? (
        <>
          <h1 className="font-outfit font-extrabold text-3xl text-brand-ink mb-2">Şifreni sıfırla</h1>
          <p className="font-nunito text-brand-ink2 mb-8">E-posta adresini yaz, sana yeni şifre bağlantısını gönderelim.</p>
          <form onSubmit={submit} className="flex flex-col gap-4">
            <div>
              <label className="font-nunito text-sm font-semibold text-brand-ink2 block mb-1.5">E-posta</label>
              <input
                data-testid="forgot-email-input"
                type="email"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="w-full bg-white border border-black/10 rounded-2xl px-4 py-3.5 font-nunito text-brand-ink focus:outline-none focus:ring-2 focus:ring-brand-primary"
                placeholder="ornek@mail.com"
              />
            </div>
            <button
              data-testid="forgot-submit-button"
              type="submit"
              disabled={loading}
              className="w-full bg-brand-primary text-brand-ink font-outfit font-bold text-lg py-4 rounded-full shadow-[0_4px_18px_rgba(255,183,3,0.45)] disabled:opacity-50"
            >{loading ? "Gönderiliyor..." : "Bağlantı gönder"}</button>
          </form>
        </>
      ) : (
        <div className="flex flex-col items-center text-center py-8" data-testid="forgot-sent-view">
          <div className="w-20 h-20 rounded-full bg-good/20 flex items-center justify-center mb-5">
            <EnvelopeSimple size={40} weight="duotone" color="#2A9D8F" />
          </div>
          <h1 className="font-outfit font-extrabold text-2xl text-brand-ink mb-3">Kontrol et 📨</h1>
          <p className="font-nunito text-brand-ink2 mb-2">Eğer bu e-posta kayıtlıysa şifre sıfırlama bağlantısı gönderdik.</p>
          <p className="font-nunito text-brand-ink2 text-sm mb-8">Gelen kutunu (ve gerekirse spam klasörünü) kontrol et. Bağlantı 1 saat geçerli.</p>
          <button onClick={() => nav("/login")} data-testid="forgot-goto-login" className="w-full bg-brand-ink text-white font-outfit font-bold py-4 rounded-full">Giriş ekranına dön</button>
        </div>
      )}
    </div>
  );
}
